import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import router from './router'
import axios from 'axios'
import * as echarts from 'echarts'
import { Menu, Switch,Col,Image,Card, Message,TimePicker,Autocomplete,MessageBox, MenuItem, Submenu, DatePicker,Tooltip, Dropdown,RadioGroup,Radio,CheckboxGroup,Checkbox, DropdownMenu,Select, Option, DropdownItem,Input,Form,FormItem, TimeSelect,Table,Dialog,TableColumn,Button,Pagination, Loading } from 'element-ui'
import dataV from '@jiaminghi/data-view'
import { Notification } from 'element-ui'
import { getAuthorities } from '@/components/function/authorities'
import { getMenusOfCurrentUser } from '@/api/auth/menu'
import hevueImgPreview from 'hevue-img-preview'
import i18n from './lang'

import './plugins/antd-ui'
import './plugins/count-to'
import './plugins/draggable-resizable'
import 'element-ui/lib/theme-chalk/index.css'
// import 'animate.css'
import './style/index.less'
import 'echarts-extension-amap'
import '@/style/iconfont.css'
import VueI18n from 'vue-i18n'

document.title = i18n.t('documentTitle')
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$notify = Notification
Vue.prototype.$EM = Message;
Vue.prototype.$close = MessageBox.close
Vue.prototype.getAuthorities = getAuthorities
Vue.prototype.$Mconfirm = MessageBox.confirm
Vue.prototype.globalClick = function (callback) {
  window.addEventListener('click', e => {
    callback(e)
  })
}

Vue.use(DatePicker)
Vue.use(hevueImgPreview)
Vue.use(TimePicker)
Vue.use(Dropdown)
Vue.use(Card)
Vue.use(Autocomplete)
Vue.use(Col)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Tooltip)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(TimeSelect)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(dataV)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Loading)

Vue.use(VueI18n)

const vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
})

// vue.$mount('#app')
async function beforeMount() {
  try {
    (window.location.href.split("?")[1]?.split("&") || []).map(h => h.split("=")).forEach(h => {
      if (h[0] === "rToken") {
        localStorage.setItem("rToken", JSON.stringify(h[1]))
      }
      if (h[0] === "token") {
        localStorage.setItem("token", JSON.stringify(h[1]))
      }
    })
    const rToken = JSON.parse(localStorage.getItem('rToken'))
    if (rToken) {
      const { data } = await axios({
        url: `https://ygk.deman.cn/api/v2/auth/accessToken?refreshToken=${rToken}`,
        // url: `http://10.55.50.85:10000/api/auth/accessToken?refreshToken=${rToken}`,
        // url: `http://10.55.50.87:10000/api/auth/accessToken?refreshToken=${rToken}`,
        method: 'GET'
      })
      localStorage.setItem('token', JSON.stringify(data.data))
      localStorage.setItem('start', +new Date())
      const menus = await getMenusOfCurrentUser()
      localStorage.setItem('menus', JSON.stringify(menus.data))
    }
  } catch(e) {
    console.log(e)
  } finally {
    vue.$mount('#app')
  }
}

beforeMount()
